var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingapore = function SvgSingapore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Singapore_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 9.09H9.091v181.82h181.818V9.091Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#Singapore_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DA2440",
    d: "M9.09 100.017h181.82V100c0-50.209-40.7-90.91-90.909-90.91S9.09 49.792 9.09 100v.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M190.909 100.017H9.091c0 50.2 40.709 90.892 90.909 90.892s90.9-40.692 90.909-90.892M74.75 86.81a34.124 34.124 0 0 1-11.315 1.919c-18.896 0-34.222-15.318-34.222-34.24 0-5.879 1.485-11.41 4.098-16.238a91.37 91.37 0 0 1 20.693-16.656 34.187 34.187 0 0 1 9.44-1.32c3.968 0 7.78.678 11.323 1.92-17.237.694-31.027 14.91-31.027 32.294 0 17.385 13.79 31.626 31.027 32.33l-.017-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m67.661 55.305-4.645-3.551-4.655 3.551 1.789-5.74-4.654-3.56 5.757.044 1.763-5.775 1.788 5.775 5.74-.044-4.671 3.56 1.788 5.74m36.488 0-4.654-3.551-4.647 3.551 1.798-5.74-4.68-3.56 5.766.044 1.763-5.775 1.77 5.775 5.758-.044-4.663 3.56 1.789 5.74M85.905 41.794l-4.637-3.587-4.637 3.587 1.772-5.775-4.655-3.517h5.749l1.771-5.775 1.79 5.775 5.748-.035-4.663 3.552 1.762 5.775M74.497 76.988l-4.663-3.551-4.638 3.551 1.78-5.774-4.663-3.526h5.75l1.77-5.775 1.763 5.775h5.758l-4.655 3.526 1.798 5.774m22.83 0-4.672-3.551-4.637 3.551 1.797-5.774-4.663-3.526h5.757l1.746-5.775 1.78 5.775h5.749l-4.655 3.526 1.797 5.774"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgSingapore;